// extracted by mini-css-extract-plugin
export default {"skillTag":"SkillTag_skillTag__JQ86L"};